import React, { useCallback, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { selectInputErrors } from "../../features/errors/errorsSlice";
import { useAuthUser } from "../../features/auth/authHooks";
import Page from "../../types/Page";
import Layout from "../../components/Layout";
import PageHeader from "../../components/PageHeader";
import { Col, Row, Spinner } from "react-bootstrap";
import ReactDatePicker from "react-datepicker";
import CabinCard from "../../components/CabinCard";
import {
  AccommodationListItem,
  AccommodationQueryFilters,
  getAccommodationsAsync,
  selectAccommodationItems,
  selectAccommodationsLoadingStatus,
} from "../AccommodationsPage/accommodationsSlice";
import { LOADING_STATUS } from "../../common/constants";
import {
  InitialAllAccommodationsPaginationParameters,
  InitialPaginationParameters,
} from "../../types/pagination.types";
import {
  BookingItem,
  BookingsRequest,
  BookingType,
  getBookingsAsync,
} from "./bookingsSlice";
import { unwrapResult } from "@reduxjs/toolkit";
import AccommodationBookings from "./AccommodationBookings";
import BookingsStartingInSevenDays from "./BookingsStartingInSevenDays";

const BookingsPageType: Page = {
  ActiveTab: "Bookings",
  DisplayName: "Varauskalenteri",
  LinkUrl: "/bookings",
  Path: "/bookings",
  RouteName: "bookings",
};

const demoDate1 = new Date();
const demoMonth = demoDate1.getMonth();
const demoYear = demoDate1.getFullYear();
const demoDate2 = new Date(demoYear, demoMonth, demoDate1.getDate() + 1);
const excludedDays = [
  new Date(`${demoYear}/${demoMonth + 1}/1`),
  new Date(`${demoYear}/${demoMonth + 1}/20`),
  new Date(`${demoYear}/${demoMonth + 1}/22`),
];

const BookingsPage = () => {
  const inputErrors = useAppSelector(selectInputErrors);
  const accommodations = useAppSelector(selectAccommodationItems);
  //const bookings = useAppSelector(selectBookingItems);
  const [submitted, setSubmitted] = useState(false);
  const accommodationsLoadingStatus = useAppSelector(
    selectAccommodationsLoadingStatus,
  );
  const dispatch = useAppDispatch();
  const { ownerAccountId } = useAuthUser();
  const [filtering, setFiltering] = useState<AccommodationQueryFilters>({
    PageNumber: InitialAllAccommodationsPaginationParameters.PageNumber,
    PageSize: InitialAllAccommodationsPaginationParameters.PageSize,
    filterCriteria: {
      showDeleted: false,
      searchString: undefined,
      accommodationNumber: undefined,
      novelty: undefined,
      showInWebShop: undefined,
      showInOwnerPage: undefined,
      accommodationGroupId: undefined,
      accountId: ownerAccountId,
    },
  });
  const initFetch = useCallback(() => {
    dispatch(getAccommodationsAsync(filtering));
  }, [dispatch, ownerAccountId]);
  useEffect(() => {
    initFetch();
  }, [initFetch, ownerAccountId]);
  if (accommodationsLoadingStatus == LOADING_STATUS.LOADING) {
    return (
      <div className={BookingsPageType.RouteName}>
        <Layout CurrentPage={BookingsPageType}>
          <PageHeader
            Title={BookingsPageType.DisplayName}
            SubTitle={BookingsPageType.DisplayParentName}
            Back={false}
            Icon="calendar2-week"
          />
          <div className="d-flex gap-16 align-items-center">
            <Spinner animation="border" />
            <span>Ladataan kohteita...</span>
          </div>
        </Layout>
      </div>
    );
  }
  const allAccommodationIds = (accommodations || []).map((a) => a.id);
  let show = true;
  return (
    <div className={BookingsPageType.RouteName}>
      <Layout CurrentPage={BookingsPageType}>
        <PageHeader
          Title={BookingsPageType.DisplayName}
          SubTitle={BookingsPageType.DisplayParentName}
          Back={false}
          Icon="calendar2-week"
        />
        <div className="mb-24">
          <BookingsStartingInSevenDays></BookingsStartingInSevenDays>
        </div>
        <h2 className="h5 mb-16">Kohteet</h2>
        <div className="d-grid gap-16 gap-lg-32">
          <>
            {accommodations != null &&
              accommodations.map((accommodation, index) => {
                if (show) {
                  //show = false;
                  return (
                    <AccommodationBookings
                      key={accommodation.accommodationNumber}
                      accommodation={accommodation}
                      allAccommodationIds={allAccommodationIds}
                      useBatchCalendarFetch={true}
                      isBatchCalendarFetchLeader={index === 0}
                    />
                  );
                }
              })}
          </>
        </div>
      </Layout>
    </div>
  );
};

export default BookingsPage;
